import { makeAutoObservable } from 'mobx';
import { createHealthDataPoint, HealthDataPoint } from './HealthDataPoint';
import { HealthDataPointQuantityType } from './HealthDataPointQuantityType';
import { BodyValueKeys } from '../Athlete/BodyValueKeys';
import { HttpBackend } from '../../Services/Http/HttpBackend';
import Qty from 'js-quantities';

export type HealthDataPointQuantity = HealthDataPoint & {
  type: HealthDataPointQuantityType;
  value: number;
  readonly qty: Qty;
  readonly valueImperial: Qty;
  getValue(metric?: boolean): number;
  getUnit(metric?: boolean): string | undefined;
  save(): Promise<HealthDataPointQuantity>;
  update(): Promise<any>;
};

export function createHealthDataPointQuantity(json?: Partial<HealthDataPointQuantity>): HealthDataPointQuantity {
  return makeAutoObservable({
    ...createHealthDataPoint(json),
    type: json?.type ?? HealthDataPointQuantityType.activeEnergyBurned,
    value: json?.value ?? 0,

    get qty(): Qty {
      const definition = BodyValueKeys[this.type];
      if (definition?.unit) {
        return new Qty(!isNaN(this.value) && isFinite(this.value) ? this.value : 0, definition.unit);
      }
      return new Qty(!isNaN(this.value) && isFinite(this.value) ? this.value : 0);
    },

    get valueImperial(): Qty {
      const definition = BodyValueKeys[this.type];
      if (definition?.imperial?.unit) {
        return this.qty.to(definition.imperial.unit);
      }
      return this.qty;
    },

    getValue(metric: boolean = true): number {
      return !metric ? this.valueImperial.toPrec(0.1).scalar : this.qty.toPrec(0.1).scalar;
    },

    getUnit(metric: boolean = true): string | undefined {
      const definition = BodyValueKeys[this.type];
      if (metric) {
        return definition?.unit;
      }
      return definition?.imperial?.unit;
    },

    save(): Promise<HealthDataPointQuantity> {
      return HttpBackend.post(`/athlete/health-data`, this)
        .then((result) => {
          this.id = result.id || this.id;
        })
        .then(() => this);
    },

    update(): Promise<any> {
      return HttpBackend.put(`/athlete/health-data/${this.id}`, this);
    },
  });
}
